import {
  Box,
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { isNotMobile } from 'utils/helpers'
import { COLORS } from 'utils/styles'

export const UserInformation = ({
  profilePicture,
  coverPicture,
  fullName,
  quote
}) => (
  <>
    <Stack
      width="100%"
      position="relative"
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <Box
        backgroundImage={coverPicture || null}
        backgroundColor={null || 'gray.700'}
        bgPosition="100%"
        bgRepeat="no-repeat"
        bgSize="455px 110px"
        position="absolute"
        width="146%"
        height="95px"
        padding="20px"
        top="-24px"
        left={-20}
        data-name="coverPicture"
        sx={{
          '@media (max-width: 470px)': {
            width: '100vw'
          }
        }}
      >
        <Box />
      </Box>

      <Stack
        alignItems="center"
        direction="row"
        spacing="10px"
        position="relative"
        width="100%"
        sx={{
          '@media (max-width: 480px)': {
            left: '-40px !important'
          }
        }}
      >
        <Image
          boxSize="65px"
          position="relative"
          objectFit="cover"
          src={profilePicture || ImagesPng.DefaultImage}
          alt="User Image"
          borderRadius="full"
          top="-10px"
          border={`1.5px solid ${COLORS.gray_op8}`}
        />
        <Stack
          direction="column"
          spacing="12px"
          position="relative"
          top="-10px"
        >
          <Text
            background={COLORS.transparentGray}
            p="1.5px 15px"
            borderRadius={3}
            data-name="fullName"
            width="auto"
            fontSize="17px"
          >
            {fullName}
          </Text>
        </Stack>
      </Stack>

      <Box />
    </Stack>
    {
      quote === null
        ? ''
        : (
          <Stack
            direction="column"
            spacing="10px"
            padding="10px 5px"
            maxHeight="100px"
            overflow="auto"
            borderRadius="5px"
            backgroundImage={
              isNotMobile()
                ? COLORS.whiteBlackGradientLeftToRight
                : COLORS.whiteBlackGradientRightToLeft
            }
            sx={{ marginTop: '5px !important' }}
          >
            <Text
              align="center"
              data-name="quote"
              whiteSpace="pre-wrap"
            >
              {quote}
            </Text>
          </Stack>
        )
    }
  </>
)
